import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_button = _resolveComponent("home-button")!

  return (_openBlock(), _createBlock(_component_home_button, {
    "background-color": $options.backgroundColor,
    "file-name": $options.backgroundPhoto,
    onClick: $options.handleWelcomeButtonClick
  }, null, 8, ["background-color", "file-name", "onClick"]))
}